import React from "react";
import "./AboutMission.css";

const AboutMission = () => {
  return (
    <section className="about-mission-wrapper">
      <div className="about-mission-container">

        {/* Vision */}
        <div className="about-mission-box vision-bg">
          <div className="about-mission-overlay"></div>
          <div className="about-mission-content">
            <h2>Our Vision</h2>
            <p>
              To create an inclusive educational environment where specially-abled individuals are empowered as educators, serving as role models and mentors. We envision a society where disability is not a barrier to excellence in teaching, and where every student, regardless of their physical abilities, has access to quality education and inspiration.
            </p>
          </div>
        </div>

        {/* Mission */}
        <div className="about-mission-box mission-bg">
          <div className="about-mission-overlay"></div>
          <div className="about-mission-content">
            <h2>Our Mission</h2>
            <p>
              To provide quality teacher education with a special focus on inclusivity by employing specially-abled faculty members who teach and mentor disabled students. We are committed to breaking barriers, fostering empowerment, and proving that determination and dedication transcend physical limitations. Our mission is to build a community where every individual can contribute meaningfully to education and society.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default AboutMission;
